import { render, staticRenderFns } from "./LiveCard.vue?vue&type=template&id=3b1c76d7&"
import script from "./LiveCard.vue?vue&type=script&lang=ts&"
export * from "./LiveCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports